<h2 mat-dialog-title>
  <span data-cy="dialog-title">
    @if (data.icon) {
      <mat-icon>{{ data.icon }}</mat-icon>
    }
    {{ data.title }}
  </span>
</h2>
<mat-dialog-content [innerHTML]="data.message" data-cy="dialog-content"></mat-dialog-content>
<mat-dialog-actions align="end" data-cy="dialog-actions">
  @if (data.cancelButtonText) {
    <button id="dialog-cancel-button" mat-button mat-dialog-close data-cy="dialog-actions-cancel" tabindex="-1">
      {{ data.cancelButtonText }}
    </button>
  }
  @if (data.confirmButtonText) {
    <button
      id="dialog-confirm-button"
      mat-button
      color="primary"
      [mat-dialog-close]="true"
      data-cy="dialog-actions-confirm"
      tabindex="-1">
      {{ data.confirmButtonText }}
    </button>
  }
  @if (data.linkButton) {
    <button
      id="dialog-link-button"
      mat-button
      color="primary"
      (click)="redirect()"
      [mat-dialog-close]="true"
      data-cy="dialog-actions-link"
      tabindex="-1">
      {{ data.linkButton.text }}
    </button>
  }
</mat-dialog-actions>
